export default "https://cdn-static.gokick.com/assets/62cc856e78696df0fd8dcc0a94c6851d482ca838/images/one-pack.d480e98fa5cc774d464fa35a18a8809f.png";